import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EXT_IntegranteCambioEMail from "../../Componentes/Compuestos/Complejos/Clientes/EXT_IntegranteCambioEMail"
import { PaginaExterna } from "../../Componentes/Compuestos/Paginas/PaginaExterna";
import { function_ABM_EEX_Clientes_Generar_JSON, function_ABM_EEX_Clientes_Generar_JSONBasico, function_ABM_EEX_Clientes_Leer, function_ABM_EEX_Clientes_Modificar, function_ABM_EEX_Clientes_ModificarBasico } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";

export const _EXT_Reservas_IntegranteCambioEMailDevolucion = () => {

  const { CodigoCompania, CodigoEmpresa, CodigoPlanta, IdCliente, EMailParaCambiar } = useParams();

  const [texto, setTexto] = useState("");

  useEffect(() => {

    const modificarCliente = async () => {
      try {
        const resultCliente = await function_ABM_EEX_Clientes_Leer(IdCliente)

        const resultGenerador = await function_ABM_EEX_Clientes_ModificarBasico(IdCliente, resultCliente.data.Apellido, resultCliente.data.Nombre, resultCliente.data.CUIT, resultCliente.data.FechaNacimiento, resultCliente.data.Password, EMailParaCambiar, resultCliente.data.Telefonos)

        setTexto("Se ha realizado el cambio de E-Mail")
      } catch (error) {
        setTexto(error.message)
      }
    };

    modificarCliente();
  }, []);


  return (
    <div>
      <PaginaExterna
        CodigoCompania={CodigoCompania}
        CodigoEmpresa={CodigoEmpresa}
        CodigoPlanta={CodigoPlanta} >
        {texto && <p style={{ fontSize: '28px', color: '#0077cc', marginTop: '20px', fontWeight: 'bold' }}>
          {texto}
        </p>}
      </PaginaExterna>
    </div>
  );
};
